/***********************/
/* util functions      */
/***********************/
// getPlanId - Takes in the cart and a product ID and returns the plan ID for that product
function getPlanProduct(cart, productId) {
    return cart.items.filter((item) => productId == item.properties['_Extend.ProductId'])[0];
}

function productAnalytics(productId, productQuantity = 1) {
    if (productId) {
        Extend.trackProductAddedToCart({ productId, productQuantity });
    } else {
        console.warn("Extend: Product id is " + productId)
    }
}

function cartAnalytics(oldCart, newCart) {
    try {
        //if there is an old or new cart with items. 
        if (oldCart && newCart && oldCart.items && newCart.items) { 
            // Triggers if an item has been removed
            if (oldCart.items.length > newCart.items.length) {

                oldCart.items.forEach((oldCartItem) => {
                    let matchedItems = newCart.items.filter((newCartItem) => oldCartItem.id == newCartItem.id);

                    if (!matchedItems.length) {
                        if (oldCartItem.properties['__Extend.IsExtendWarranty']) {
                            Extend.trackOfferRemovedFromCart({ productId: oldCartItem.properties['_Extend.ProductId'], planId: oldCartItem.properties['_Extend.PlanId']});
                        } else if (oldCartItem.id) {
                            Exetnd.trackProductRemovedFromCart({ productId: oldCartItem.id });
                        }
                    }
                });

                // Triggers if an item quantity has changed
            } else if (oldCart.item_count != newCart.item_count) {
                oldCart.items.forEach((oldCartItem) => {

                    // Get non-Extend updated items
                    if (oldCartItem.vendor == 'Extend') return;
                    
                    let newCartItem = newCart.items.filter((newCartItem) => oldCartItem.id == newCartItem.id && oldCartItem.quantity != newCartItem.quantity)[0];

                    if (ExtendShopify.warrantyAlreadyInCart(oldCartItem.id, oldCart.items)) {
                        let attachedPlan = getPlanProduct(newCart, oldCartItem.id);
                        Extend.trackOfferUpdated({
                            productId: oldCartItem.id,
                            updates: {
                                warrantyQuantity: attachedPlan.quantity,
                                productQuantity: newCartItem.quantity
                            }
                        })
                    } else {
                        Extend.trackProductUpdated({
                            productId: oldCartItem.id,
                            updates: {
                                productQuantity: newCartItem.quantity
                            }
                        })
                    }
                });
            }
        } else {
            console.warn("EXTEND: corrupt cart objects");
        }
    } catch(error) {
        console.error("EXTEND: " + error);
    }
}

export { productAnalytics, cartAnalytics };